/* ===========================
   DOM ELEMENTS
=========================== */

const cartLoader = document.getElementById('global-cart-loader');

function showCartLoader() {
  if (!cartLoader) return;
  cartLoader.classList.remove('hidden');
  cartLoader.setAttribute('aria-hidden', 'false');
}

function hideCartLoader() {
  if (!cartLoader) return;
  cartLoader.classList.add('hidden');
  cartLoader.setAttribute('aria-hidden', 'true');
}


// const addToCart = document.getElementById('add_to_cart');
const addToCart = document.querySelectorAll('.add_to_cart_product');
// const variant_option = document.getElementById('product_variant');
const variant_option = document.querySelectorAll('.product-variant-select');
const color_option = document.querySelectorAll('.product-color-select');
const product_id_input = document.getElementById('product_id');
const variant_pack_size = document.getElementById('variant_pack_size');
const cart_notification_count = document.getElementById('cart-notification-count');
const update_price = document.querySelector('.update_price');
const quickViewWrapper = document.querySelector('#quickViewWrapper')
const add_to_cart_clr_btn = document.querySelectorAll('.add_to_cart_product_color');

let api_base_url = 'https://shopifyapi.ukcable-ties.co.uk';


function openCartDrawer() {
  const cartDrawer = document.getElementById('offcanvas__mini_cart');
  if (!cartDrawer) return;

  cartDrawer.classList.add('active');
  cartDrawer.setAttribute('open', '');

  document.body.classList.add('overflow-hidden');

  document.dispatchEvent(new CustomEvent('cart:open'));

}

async function refreshCartDrawer() {
  const response = await fetch(
    `${window.Shopify.routes.root}?sections=cart-notification-product,cart-notification-subtotal`
  );

  if (!response.ok) return;

  const sections = await response.json();

  // Update cart items
  const productContainer = document.getElementById('cart-notification-product');
  if (productContainer && sections['cart-notification-product']) {
    productContainer.innerHTML = sections['cart-notification-product'];
  }

  // Update subtotal
  const subtotalEl = document.getElementById('cart-notification-subtotal');
  if (subtotalEl && sections['cart-notification-subtotal']) {
    subtotalEl.innerHTML = sections['cart-notification-subtotal'];
  }

  // Notify theme JS (important for animations / bindings)
  document.dispatchEvent(new CustomEvent('cart:updated'));
}

async function updateCartEmptyState() {
  const cart = await fetch_cart();
  const isEmpty = cart.item_count === 0;

  const emptyMessage = document.querySelector('.empty__cart__item');
  const cartItems = document.querySelector('.cart__items');
  const cartFooter = document.querySelector('.cart-notification__links');

  if (!emptyMessage || !cartItems || !cartFooter) return;

  if (isEmpty) {
    emptyMessage.classList.remove('no-js-inline');
    cartItems.classList.add('no-js-inline');
    cartFooter.classList.add('no-js-inline');
  } else {
    emptyMessage.classList.add('no-js-inline');
    cartItems.classList.remove('no-js-inline');
    cartFooter.classList.remove('no-js-inline');
  }
}


/* ===========================
   CART
=========================== */

async function fetch_cart() {
  const response = await fetch('/cart.js');
  if (!response.ok) throw new Error('Failed to fetch cart');
  return await response.json();
}


/* ===========================
   PRODUCT API
=========================== */

async function get_product_detail(product_id) {
  const response = await fetch(
    `${api_base_url}/fetch-products-data/${product_id}`
  );
  if (!response.ok) throw new Error('Product fetch failed');
  return await response.json();
}


/* ===========================
   FILTER VARIANTS BY SIZE
=========================== */

async function filter_variant(size_value, product_id) {
  const product_detail = await get_product_detail(product_id);
  const filterd_variants = product_detail.product.variants
    .filter(v =>
      v.option1 === size_value &&
      parseFloat(v.price) > 0
    )
    .sort((a, b) => parseInt(a.option2) - parseInt(b.option2));
    const maxPriceVariant = filterd_variants.reduce((max, v) => {
      return parseFloat(v.price) < parseFloat(max.price) ? v : max;
    });
    if(update_price){
      update_price.innerHTML = maxPriceVariant.price

    }

  return filterd_variants;
}


async function filterColorVariant(variant_value,product_id,selected_color) {
  console.log(product_id);
  
    const product_detail = await get_product_detail(product_id);
    const filtered_variant = product_detail.product.variants.filter(
      variant =>
        variant.option1 === variant_value &&
        variant.option3 === selected_color
      ).sort((a, b) => Number(a.option2) - Number(b.option2));
    
    console.log(filtered_variant);
    
      let html = `
      <div class="form-group">
        <ul class="list-unstyled discount-list">
          <li><strong>No. of Pack(s)</strong><span>Price per Pack</span></li>
    `;
    filtered_variant.forEach(v => {
      html += `
        <li>
          <strong>${v.option2}</strong>
          <span>£${v.price}</span>
        </li>
      `;
    });
    html += `</ul></div>`;
    

  document.getElementById('color-pack-size-container').innerHTML = html;
  return filtered_variant;
}


/* ===========================
   FIND CART ITEMS BY PRODUCT + SIZE
=========================== */

async function filterByProductAndSize(product_id, size_value) {
  const cart = await fetch_cart();

  return cart.items.filter(item =>
    item.product_id == product_id &&
    item.options_with_values?.some(
      opt => opt.value === size_value
    )
  );
}


/* ===========================
   REMOVE EXISTING CART ITEMS
=========================== */

async function removeCartItems(items) {
  const cart = await fetch_cart();

  for (let i = 0; i < cart.items.length; i++) {
    if (items.some(it => it.key === cart.items[i].key)) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: i + 1,
          quantity: 0
        })
      });
    }
  }
}


/* ===========================
   FIND BEST TIER VARIANT
=========================== */

function findBestTierVariant(variants, total_qty) {
  let best = null;

  variants.forEach(v => {
    if (total_qty >= parseInt(v.option2)) {
      best = v;
    }
  });

  return best;
}


/* ===========================
   ADD VARIANT TO CART
=========================== */

async function addVariant(variant_id, quantity) {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variant_id,
      quantity: quantity
    })
  });
}


/* ===========================
   MAIN TIER LOGIC
=========================== */

async function applyTierPricing(product_id, size_value, entered_qty,is_cart) {

  console.log(product_id,size_value,entered_qty);

  const matchedItems = await filterByProductAndSize(
    product_id,
    size_value
  );

  let total_qty = parseInt(entered_qty, 10);

  if(!is_cart){
    const existing_qty = matchedItems.reduce(
      (sum, item) => sum + item.quantity,
      0
    );
    total_qty = existing_qty + parseInt(entered_qty);
  }

  if (matchedItems.length) {
    await removeCartItems(matchedItems);
  }

  const variants = await filter_variant(size_value, product_id);
  const bestVariant = findBestTierVariant(variants, total_qty);

  if (!bestVariant) return;

  await addVariant(bestVariant.id, total_qty);
}



async function filter_option_second(value) {
  const product_id = product_id_input.value;
  const product_detail = await get_product_detail(product_id);

  const filtered = product_detail.product.variants.filter(
    v => v.option1 === value
  );

  const uniqueOption3 = [...new Set(filtered.map(v => v.option3))];

  const extra_filter = document.querySelector('#product_variant_color');

  extra_filter.innerHTML = '';

  const placeholder = document.createElement('option');
  placeholder.value = '';
  placeholder.textContent = '--Please Select--';
  placeholder.disabled = true;
  placeholder.selected = true;
  extra_filter.appendChild(placeholder);

  uniqueOption3.forEach(color => {
    const option = document.createElement('option');
    option.value = color;
    option.textContent = color;
    extra_filter.appendChild(option);
  });
}



/* ===========================
   VARIANT CHANGE (DISPLAY)
=========================== */
variant_option.forEach(variant => {
    variant.addEventListener('change', async (e) => {
    const selected_variant = e.target.value;
    
    const product_id = product_id_input.value;
    
    const extra_filter = document.querySelector('#product_variant_color')

    if (extra_filter) {
      console.log(filter_option_second(selected_variant));
    }
    else{

      const display_variant = await filter_variant(
        selected_variant,
        product_id
      );

      if (!display_variant.length) return;

      let html = `
        <div class="form-group">
          <ul class="list-unstyled discount-list">
            <li><strong>No. of Pack(s)</strong><span>Price per Pack</span></li>
      `;

      display_variant.forEach(v => {
        html += `
          <li>
            <strong>${v.option2}</strong>
            <span>£${v.price}</span>
          </li>
        `;
      });

      html += `</ul></div>`;
      document.getElementById('pack-size-container').innerHTML = html;
    }
  });
});

color_option.forEach(color => {
    color.addEventListener('change',(e)=>{
      console.log(e.target.value);
    })
});


let selectedVariant = null;
let selectedColor = null;

async function findColorVaraint(variant, color) {
  if (!variant || !color) return; 
    const product_id = product_id_input.value;

  let filtered_color_variant =  await filterColorVariant(variant,product_id,color)

  return filtered_color_variant
}

variant_option.forEach(variant => {
  variant.addEventListener('change', (e) => {
    selectedVariant = e.target.value;
    findColorVaraint(selectedVariant, selectedColor);
  });
});

color_option.forEach(color => {
  color.addEventListener('change', (e) => {
    selectedColor = e.target.value;
    findColorVaraint(selectedVariant, selectedColor);
  });
});


if (quickViewWrapper) {
  quickViewWrapper.addEventListener('change', async (e) => {
    const add_to_car_btn = quickViewWrapper.querySelector('.add_to_cart_product');
    
    const variant = e.target.closest('.product-variant-select');
    if (!variant) return;

    const productIdInput = quickViewWrapper.querySelector("input[name='product-id']");
    if (!productIdInput) return;

    const product_id = productIdInput.value;


    const display_variant = await filter_variant(variant.value, product_id);
    if (!display_variant || !display_variant.length) return;
    
    let html = `
      <div class="form-group">
        <ul class="list-unstyled discount-list">
          <li><strong>No. of Pack(s)</strong><span>Price per Pack</span></li>
    `;
    display_variant.forEach(v => {
      html += `
        <li>
          <strong>${v.option2}</strong>
          <span>£${v.price}</span>
        </li>
      `;
    });
    html += `</ul></div>`;

    const packSizeContainer = quickViewWrapper.querySelector('#pack-size-container');
    if (packSizeContainer) {
      packSizeContainer.innerHTML = html;
    }
  });
}

if (quickViewWrapper) {
  let selectedVariantQV = null;
  let selectedColorQV = null;

  // Handle variant change
  quickViewWrapper.addEventListener('change', async (e) => {
    const target = e.target;

    // Variant select
    if (target.classList.contains('product-variant-select')) {
      selectedVariantQV = target.value;

      const colorSelect = quickViewWrapper.querySelector('.product-color-select');
      selectedColorQV = colorSelect ? colorSelect.value : null;

      if (!selectedVariantQV) return;

      await updateQuickViewPackSize(selectedVariantQV, selectedColorQV);
    }

    // Color select
    if (target.classList.contains('product-color-select')) {
      selectedColorQV = target.value;

      const variantSelect = quickViewWrapper.querySelector('.product-variant-select');
      selectedVariantQV = variantSelect ? variantSelect.value : null;

      if (!selectedVariantQV || !selectedColorQV) return;

      await updateQuickViewPackSize(selectedVariantQV, selectedColorQV);
    }
  });

  // // Add to cart button inside quick view
  // quickViewWrapper.addEventListener('click', async (e) => {

  //   let selected_variant_product_clr = document.querySelector('#product_variant_color')
  //   if (!e.target.classList.contains('add_to_cart_product')) return;

  //   e.preventDefault();

  //   const addBtn = e.target;
  //   const productIdInput = quickViewWrapper.querySelector("input[name='product-id']");
  //   if (!productIdInput) return;

  //   const product_id = productIdInput.value;
  //   const qtyInput = quickViewWrapper.querySelector("input[name='quantity']");
  //   const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

  //   if (!selectedVariantQV) {
  //     alert("Please select a variant");
  //     return;
  //   }
  //   if(selected_variant_product_clr){

  //     if (!selectedColorQV) {
  //       alert("Please select a color");
  //       return;
  //     }
  //   }

  //   await applyColorTierPricing(product_id, selectedVariantQV, qty, selectedColorQV);

  //   await refreshCartDrawer();
  //   await updateCartEmptyState();

  //   const cart = await fetch_cart();
  //   cart_notification_count.innerHTML = cart.item_count;

  //   openCartDrawer();
  // });
// Add to cart button inside quick view
quickViewWrapper.addEventListener('click', async (e) => {
  if (!e.target.classList.contains('add_to_cart_product')) return;

  e.preventDefault();

  showCartLoader(); // 🔹 START loader

  try {
    let selected_variant_product_clr = document.querySelector('#product_variant_color');

    const productIdInput = quickViewWrapper.querySelector("input[name='product-id']");
    if (!productIdInput) return;

    const product_id = productIdInput.value;
    const qtyInput = quickViewWrapper.querySelector("input[name='quantity']");
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    if (!selectedVariantQV) {
      alert("Please select a variant");
      return;
    }

    if (selected_variant_product_clr && !selectedColorQV) {
      alert("Please select a color");
      return;
    }

    await applyColorTierPricing(product_id, selectedVariantQV, qty, selectedColorQV);
    await refreshCartDrawer();
    await updateCartEmptyState();

    const cart = await fetch_cart();
    cart_notification_count.innerHTML = cart.item_count;

    openCartDrawer();

  } catch (err) {
    console.error('Quick view add to cart error:', err);
  } finally {
    hideCartLoader(); // 🔹 STOP loader (always)
  }
});

  // Helper function to update pack size list
  async function updateQuickViewPackSize(variant, color) {
    const productIdInput = quickViewWrapper.querySelector("input[name='product-id']");
    if (!productIdInput) return;
    const product_id = productIdInput.value;

    let filtered_variant;
    if (color) {
      filtered_variant = await filterColorVariant(variant, product_id, color);
    } else {
      filtered_variant = await filter_variant(variant, product_id);
    }

    const packSizeContainer = quickViewWrapper.querySelector('#pack-size-container');
    if (packSizeContainer && filtered_variant.length) {
      let html = `<div class="form-group">
                    <ul class="list-unstyled discount-list">
                      <li><strong>No. of Pack(s)</strong><span>Price per Pack</span></li>`;
      filtered_variant.forEach(v => {
        html += `<li><strong>${v.option2}</strong><span>£${v.price}</span></li>`;
      });
      html += `</ul></div>`;
      packSizeContainer.innerHTML = html;
    }
  }
}



/* ===========================
   ADD TO CART CLICK
=========================== */
// addToCart.forEach(addbtn => {
//   addbtn.addEventListener('click', async (e) => {
//     e.preventDefault();
//     let product_container = e.currentTarget.closest('.product__info-container')
//     let selected_variant_product = product_container.querySelector('#product_variant')
//     if(!selected_variant_product.value){
//       alert("Please Select Variant")
//     }
//     else{
//       const product_id = e.currentTarget.dataset.productId;
//       const size_value = selected_variant_product.value;
//       const qty = variant_pack_size.value;

//       await applyTierPricing(product_id, size_value, qty);

//       await refreshCartDrawer();

//       await updateCartEmptyState();

//       const cart = await fetch_cart();

//       cart_notification_count.innerHTML = cart.item_count;

//       openCartDrawer();
//     }

    
//   });
// });
addToCart.forEach(addbtn => {
  addbtn.addEventListener('click', async (e) => {
    e.preventDefault();

    showCartLoader(); 

    try {
      let product_container = e.currentTarget.closest('.product__info-container');
      let selected_variant_product = product_container.querySelector('#product_variant');

      if (!selected_variant_product.value) {
        alert("Please Select Variant");
        return;
      }

      const product_id = e.currentTarget.dataset.productId;
      const size_value = selected_variant_product.value;
      const qty = variant_pack_size.value;

      await applyTierPricing(product_id, size_value, qty);
      await refreshCartDrawer();
      await updateCartEmptyState();

      const cart = await fetch_cart();
      cart_notification_count.innerHTML = cart.item_count;

      openCartDrawer();

    } catch (err) {
      console.error('Add to cart error:', err);
    } finally {
      hideCartLoader();
    }
  });
});



// add_to_cart_clr_btn.forEach( clrBtn => {
//   clrBtn.addEventListener('click', async (e) => {
//     e.preventDefault();
//     let product_container = e.currentTarget.closest('.product__info-container')
//     let selected_variant_product = product_container.querySelector('#product_variant')
//     let selected_variant_product_clr = product_container.querySelector('#product_variant_color')
//     if(!selected_variant_product.value){
//       alert("Please Select Variant")
//     }
//     else{
//       const product_id = e.currentTarget.dataset.productId;
//       const size_value = selected_variant_product.value;
//       const qty = variant_pack_size.value;
//       const product_clr = selected_variant_product_clr.value;
//       console.log(product_id,size_value,qty,product_clr);
//       await applyColorTierPricing(product_id,size_value,qty,product_clr);
      
//     }
// })
// })
add_to_cart_clr_btn.forEach(clrBtn => {
  clrBtn.addEventListener('click', async (e) => {
    e.preventDefault();

    const button = e.currentTarget;
    const product_container = button.closest('.product__info-container');
    if (!product_container) return;

    const selected_variant_product =
      product_container.querySelector('#product_variant');
    const selected_variant_product_clr =
      product_container.querySelector('#product_variant_color');

    if (!selected_variant_product?.value) {
      alert("Please Select Variant");
      return;
    }

    if (selected_variant_product_clr && !selected_variant_product_clr.value) {
      alert("Please Select Color");
      return;
    }

    const product_id = button.dataset.productId;
    const size_value = selected_variant_product.value;
    const qty = Number(variant_pack_size?.value) || 1;
    const product_clr = selected_variant_product_clr?.value || null;

    try {
      // 🔵 START LOADER
      button.classList.add('loading');
      button.disabled = true;

      await applyColorTierPricing(
        product_id,
        size_value,
        qty,
        product_clr
      );

    } catch (err) {
      console.error('Add to cart failed:', err);
      alert('Something went wrong. Please try again.');
    } finally {
      // 🔵 STOP LOADER
      button.classList.remove('loading');
      button.disabled = false;
    }
  });
});

async function applyColorTierPricing(product_id, size_value, entered_qty, product_clr,is_cart) {
  const product_detail = await get_product_detail(product_id);

  const color_variants = product_detail.product.variants.filter(v =>
    v.option1 === size_value &&
    v.option3 === product_clr
  );

  if (!color_variants.length) return;

  let total_qty = parseInt(entered_qty, 10);
  const cart = await fetch_cart();
  const existingItem = cart.items.find(item =>
    color_variants.some(v => v.id === item.variant_id)
  );

  if(!is_cart){
      total_qty =
    (existingItem ? existingItem.quantity : 0) +
    parseInt(entered_qty, 10);
  }

  if (existingItem) {
    await removeCartItems([existingItem]);
  }

  let bestVariant = null;

  color_variants.forEach(variant => {
    const tierQty = parseInt(variant.option2, 10);

    if (total_qty >= tierQty) {
      if (!bestVariant || tierQty > parseInt(bestVariant.option2, 10)) {
        bestVariant = variant;
      }
    }
  });

  if (!bestVariant) return;

  await addVariant(bestVariant.id, total_qty);

  await refreshCartDrawer();
  await updateCartEmptyState();

  const updatedCart = await fetch_cart();
  cart_notification_count.innerHTML = updatedCart.item_count;

  openCartDrawer();
}


if (quickViewWrapper) {
   quickViewWrapper.addEventListener('change', async (e) => {
    const add_to_car_btn = quickViewWrapper.querySelector('.add_to_cart_product');
    
    const variant = e.target.closest('.product-variant-select');
    if (!variant) return;

    const productIdInput = quickViewWrapper.querySelector("input[name='product-id']");
    if (!productIdInput) return;

    const product_id = productIdInput.value;


    const display_variant = await filter_variant(variant.value, product_id);
    if (!display_variant || !display_variant.length) return;
    
    let html = `
      <div class="form-group">
        <ul class="list-unstyled discount-list">
          <li><strong>No. of Pack(s)</strong><span>Price per Pack</span></li>
    `;
    display_variant.forEach(v => {
      html += `
        <li>
          <strong>${v.option2}</strong>
          <span>£${v.price}</span>
        </li>
      `;
    });
    html += `</ul></div>`;

    const packSizeContainer = quickViewWrapper.querySelector('#pack-size-container');
    if (packSizeContainer) {
      packSizeContainer.innerHTML = html;
    }
  });
}






// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.cart-qty-input').forEach(button => {
//     button.addEventListener('click', async e => {
//       e.preventDefault();
//       button.disabled = true;

//       try {
//         const wrapper = button.previousElementSibling;
//         if (!wrapper) throw 'No quantity wrapper';

//         let product_qty = Number(
//           wrapper.querySelector('.input_prod_qty')?.value
//         );
//         if (!product_qty || product_qty < 1) product_qty = 1;

//         const productId = Number(button.dataset.product_id);
//         const sizeValue = button.dataset.cable_size;
//         const studSize = button.dataset.stud_size;

//         if (!productId || !sizeValue) throw 'Missing data';

//         if (studSize) {
//           await applyColorTierPricing(
//             productId,
//             sizeValue,
//             product_qty,
//             studSize
//           );
//         } else {
//           await applyTierPricing(
//             productId,
//             sizeValue,
//             product_qty
//           );
//         }

//       } catch (err) {
//         console.error('Pricing error:', err);
//       } finally {
//         window.location.reload();
//       }
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cart-qty-input').forEach(button => {
    button.addEventListener('click', async e => {
      e.preventDefault();
      button.disabled = true;
      let is_cart = true;
      showCartLoader(); // 🔹 START loader

      try {
        const wrapper = button.previousElementSibling;
        if (!wrapper) throw 'No quantity wrapper';

        let product_qty = Number(
          wrapper.querySelector('.input_prod_qty')?.value
        );
        if (!product_qty || product_qty < 1) product_qty = 1;

        const productId = Number(button.dataset.product_id);
        const sizeValue = button.dataset.cable_size;
        const studSize = button.dataset.stud_size;

        if (!productId || !sizeValue) throw 'Missing data';

        if (studSize) {
          await applyColorTierPricing(
            productId,
            sizeValue,
            product_qty,
            studSize,
            is_cart
          );
        } else {
          await applyTierPricing(
            productId,
            sizeValue,
            product_qty,
            is_cart
          );
        }

      } catch (err) {
        console.error('Pricing error:', err);
      } finally {
        hideCartLoader(); // 🔹 STOP loader
        window.location.reload();
      }
    });
  });
});

// only pack
document.addEventListener('DOMContentLoaded', async () => {
  const product_id = document.getElementById('product_id')?.value;
  const qtyInput = document.querySelector('#variant_pack_size');
  const addToCartBtn = document.querySelector("#add_to_cart");
  const cart_notification_count = document.querySelector('#cart_notification_count'); // make sure you have this element
   
  if (!product_id || !qtyInput || !addToCartBtn) return;

  try {
    const product = await get_product_detail(product_id);

    // Only single-option products
    if (!product.product.options || product.product.options.length !== 1) {
      document.querySelector('.pack_selector')?.style.setProperty('display', 'flex', 'important');
      return;
    }

    // Convert button to pack-mode
    addToCartBtn.classList.remove("add_to_cart_product");
    addToCartBtn.classList.add("add_to_cart_product_pack");

    // Hide default pack selector
    // document.querySelector('.pack_selector')?.remove();

    const variants = product.product.variants;

    // Display pack price table
    const packSizeContainer = document.querySelector('#pack-size-container');
    if (packSizeContainer) {
      let html = `<ul class="discount-list"><li><strong>No. of Pack(s)</strong><span>Price per Pack</span></li>`;
      variants.forEach(v => {
        html += `<li><strong>${v.option1}</strong><span>£${parseFloat(v.price).toFixed(2)}</span></li>`;
      });
      html += `</ul>`;
      packSizeContainer.innerHTML = html;
    }

    // Helper: get best variant by total quantity
    function getVariantByQty(qty) {
      const slabs = variants
        .map(v => ({ pack: parseInt(v.option1, 10), id: v.id }))
        .filter(v => !isNaN(v.pack))
        .sort((a,b) => a.pack - b.pack);

      let selected = slabs[0];
      slabs.forEach(s => { if (qty >= s.pack) selected = s; });
      return selected.id;
    }

    // Fetch cart
    async function fetchCart() {
      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error('Failed to fetch cart');
      return await res.json();
    }

    // Remove specific cart items by keys
    async function removeCartItems(items) {
      for (let i = 0; i < items.length; i++) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: i+1, quantity: 0 })
        });
      }
    }

    // Add to cart click
    addToCartBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      showCartLoader(); // 🔹 START loader
      
      let enteredQty = parseInt(qtyInput.value, 10);
      if (!enteredQty || enteredQty <= 0) {
        alert('Please enter quantity');
        return;
      }

      try {
        const cart = await fetchCart();

        // Find all items of this product (all variants)
        const matchingItems = cart.items.filter(item => item.product_id == product_id);

        // Calculate total quantity
        let totalQty = enteredQty;
        if (matchingItems.length) {
          totalQty += matchingItems.reduce((sum, item) => sum + item.quantity, 0);
          // Remove existing lines
          await removeCartItems(matchingItems);
        }

        // Pick best variant based on total quantity
        const variantId = getVariantByQty(totalQty);

        // Add to cart
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: totalQty })
        });

        if (!res.ok) throw new Error('Add to cart failed');
        const data = await res.json();
        console.log('Added to cart:', data);
      hideCartLoader(); // 🔹 STOP loader (always)

        // Refresh mini-cart / drawer
        if (typeof refreshCartDrawer === 'function') await refreshCartDrawer();
        if (typeof updateCartEmptyState === 'function') await updateCartEmptyState();

        const updatedCart = await fetchCart();
        if (cart_notification_count) cart_notification_count.innerHTML = updatedCart.item_count;

        if (typeof openCartDrawer === 'function') openCartDrawer();

      } catch (err) {
        console.error(err);
        alert('Unable to add to cart');
      }
    });

  } catch (err) {
    console.error(err);
  }
});








document.addEventListener('DOMContentLoaded', async () => {
  const cart = await fetch_cart();
  cart_notification_count.innerHTML = cart.item_count;
});




